




import { defineComponent } from "@vue/composition-api";
import { VueConstructor } from "vue";
import { MessageLink } from "@scrile/api-provider/dist/api/MessageLinksProvider";
import { getMessageItemLinkView } from "./MessageItemLinkView/index";
import MessageItemLinkFeedView from "./MessageItemLinkView/MessageItemLinkFeedView.vue";
import MessageItemLinkStoryView from "./MessageItemLinkView/MessageItemLinkStoryView.vue";

export default defineComponent({
  name: "MessageItemLink",
  components: { MessageItemLinkFeedView, MessageItemLinkStoryView },
  props: {
    messageLink: { type: Object as () => MessageLink, required: true },
    opponent: { type: Boolean, required: true },
  },
  computed: {
    viewComponent(): VueConstructor {
      return getMessageItemLinkView(this.messageLink);
    },
  },
});
